// Current organisation name for code outside React components (message maps, file names).
// BrandingProvider keeps it in sync with Admin → Branding Settings; components should use useBranding().
export const DEFAULT_ORGANISATION_NAME = 'TrinitiCare';

let currentName = DEFAULT_ORGANISATION_NAME;
try {
  const cached = JSON.parse(localStorage.getItem('gc_branding_cache_v1') || 'null');
  if (cached && cached.organisationName) currentName = cached.organisationName;
} catch {
  // ignore — no storage available
}

export function getBrandName() {
  return currentName;
}

export function setBrandName(name) {
  currentName = name || DEFAULT_ORGANISATION_NAME;
}
